<template>

  <v-container class="page page-register-account-type-selection px-8 pb-8">

    <v-row>
      <v-col cols="12" class="d-flex align-center justify-center">
        <div class="selection-title">Select your account type:</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6">
        <div class="px-8 d-flex flex-column align-center justify-center selection-container">
          <div class="option-title">
            Register a Shipper Account
          </div>
          <div class="mt-4 main-text">
            Ship your orders with {{ appName }}
          </div>
          <div class="mt-2 info-text">
            Manage your fleet of vehicles and drivers.
          </div>
          <v-btn
              width="140"
              class="mt-8"
              color="primary"
              @click="$root.goTo('register-shipper-account')">
            Continue
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6">
        <div class="px-8 d-flex flex-column align-center justify-center selection-container">
          <div class="option-title">
            Register a Receiver Account
          </div>
          <div class="mt-4 main-text">
            Manage your retail locations.
          </div>
          <div class="mt-2 info-text">
            View and manage your {{ appName }} deliveries.
          </div>
          <div class="mt-7 d-flex flex-column align-center justify-center">
            <div class="contact-text">Contact {{ appName }}</div>
            <div>support@routeleaf.com</div>
          </div>
        </div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
export default {
  name: 'RegisterAccountTypeSelectionPage',

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    }
  }
}
</script>

<style scoped>
  .page-register-account-type-selection {
    margin-top: 75px;
    max-width: 880px;
  }

  .page-register-account-type-selection .selection-title {
    font-size: 1.3rem;
    color: #727272;
    font-weight: 400;
    font-style: italic;
  }

  .page-register-account-type-selection .selection-container {
    border: 1px solid #525252;
    border-radius: 4px;
    height: 235px;
  }

  .page-register-account-type-selection .option-title {
    font-size: 1.5rem;
    color: #F8A824;
    font-weight: 400;
  }

  .page-register-account-type-selection .main-text {
    font-size: 1.14rem;
    font-weight: 500;
  }

  .page-register-account-type-selection .info-text {
    color: #d2d2d2;
  }

  .page-register-account-type-selection .contact-text {
    font-size: 1.08rem;
    color: #9c9c9c;
  }
</style>
